<template>
  <omint-page>
    <Header name="Termo de Aceite" titleLabel="Termo de Aceite" />
    <omint-slider>
      <router-view />
    </omint-slider>
    <Footer />
  </omint-page>
</template>

<script>
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";

export default {
  name: "ScreeningProgram",
  components: {
    Header,
    Footer
  }
};
</script>
